var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fold-wrapper iconfont",class:[_vm.state.isCollapse ? 'fold-open-status' : 'fold-close-status'],on:{"click":_vm.toggleFold}},[_vm._v("")])
}
var staticRenderFns = []

export { render, staticRenderFns }